
@if(statusData.status == "trialing"){
  <div id="sub-banner" [class.yellow]="statusData.daysToExpire > 7" [class.red]="statusData.daysToExpire <= 7">
    <div class="sub-banner-header"> 
      @if(statusData.daysToExpire > 5){ 
        <ion-icon name="fa-party"></ion-icon>
      } 
      @else {
        <ion-icon name="fa-triangle-warning"></ion-icon>
      }
       Testzeitraum 
    </div>
    <div class="sub-banner-text">Noch <b>{{statusData.daysToExpire}} Tage</b> kostenloser Zugriff</div>

    @if(authSrv.includesRole("access_settings")){
      <div class="abo-bttn" (click)="onAboButtonClicked.emit()">
        Abo verwalten
      </div>
    }

  </div>
}